window.jQuery = require('jquery');
//require('bootstrap-sass');
//import 'angular';
//import 'oclazyload'

// for loading styles we need to load main scss file
import styles from './styles/styles.scss';

//import 'angular'
// loading shared module
import './services/core.module';
import './constantModule';
import './stateModule'

// loading all module components
import './app.components';
//import './libs/angular-local-storage.min';

//import angularAnimate from 'angular-animate';
//import angularAria from 'angular-aria';
//import angularMaterial from 'angular-material';
//import 'angular-messages';
//import toastr from 'toastr';
import ngMaterialDatePicker from 'ng-material-datetimepicker';
//import ngFileUpload from 'ng-file-upload';

import './app/commonFilter/commonFilterModule'
// To fix issue  in text angular
angular.lowercase = text => text ? text.toLowerCase() : " ";
/*require('textangular/dist/textAngular-sanitize.min');
require('textangular/dist/textAngularSetup');*/
import './app/common-chart/commonChartModule'
import './app/single_chart/singleChartModule'
const appModule = angular
    .module('app', [
        // 3rd party modules
        'textAngular',
        'ngSanitize' ,
        'oc.lazyLoad',
        'ui.router',
        'LocalStorageModule',
        'ngAnimate',
        'ngAria',
        'ngMaterial',
        'ngMessages',
        'as.sortable',
        'ngImgCrop',
        'ngFileUpload',
        'rzModule',
        'ngMaterialDatePicker',
        // 'jquery-ui',
        // 'jquery-easyui',
        //'jsPDF',
        //'toastr',
        //'underscore',
        // shared module
        'app.core',
        // application specific modules
        'app.StateModule',
        'app.ConstantModule',
        'LocalStorageModule',
        'app.LoginModule',
        'app.navigation',
        'app.AuthDashboardModule',
        'app.commonFilter',
        'app.teacherView',
        'app.hodView',
        'app.hosView',
        'app.supervisorView',
        'app.parentView',
        'app.profileView',
        'PrivilegeDashboard',
        'PrivilegeSettings',
        'app.TeachingPlanModule',
        'TraditionalActivityModule',
        'ManageReportsModule',
        'ReportCardListsModule',
        'viewGeneratedReportData',
        'ApproveReportsModule',
        'reportCardGenConsoleModule',
        'AssignUserModule',
        'PublishedReportModule',
        'reportCardGenConsoleModule',
        'RoleHeirarchy',
        'UserHeirarchy',
        'RoleSettings',
        'UserSettings',
        'reportCardClassTeacher',
        'PublishReportModule',
        'CreateQuestionModule',
        'reportsMainComponent',
        'TpWizardModule',
        'commonChart',
        'singlechart',
        'childrenComponentModule',
        'classActivityReportcard',
        'educorePerformanceAnalysis',
        'studentFilteration',
        'academicPerformance',
        'attentionNeedingStudents',
        'performingSection',
        'sectionWiseAttention',
        'termDifference',
        'myCumulativeReport',
        'educoreStandardReport',
        'CurriculumConsoleModule',
        'academicConsole',
        'userConsole',
        'MedicalModule'
    ]);


export default appModule;


// WEBPACK FOOTER //
// ./src/app.module.js